@if (atgard) {
  <div class="map-popup-header">
    <div class="map-popup-title">{{atgard.namn || arbetsorder.namn}}</div>
    @if (!existInNavetApp()) {
      <div class="map-popup-beteckning">{{atgard.beteckning}}</div>
    }
    @if (existInNavetApp()) {
      <div class="map-popup-beteckning"><a href="{{navetAppLink()}}" target="_blank" ngbTooltip="Länk till NavetApp kräver internt nätverk eller VPN">{{atgard.beteckning}}</a></div>
    }
  </div>
  <div class="arbetsorder-header-table">
    <div class="row mx-0">
      <div class="map-popup-table-header col p-0" translate="PLANERA_ARBETSORDER_HEADER_TALLTIMMER"></div>
      <div class="map-popup-table-header col p-0" translate="PLANERA_ARBETSORDER_HEADER_GRANTIMMER"></div>
      <div class="map-popup-table-header col p-0" translate="PLANERA_ARBETSORDER_HEADER_KLENTIMMER_TALL"></div>
      <div class="map-popup-table-header col p-0" translate="PLANERA_ARBETSORDER_HEADER_KLENTIMMER_GRAN"></div>
      <div class="map-popup-table-header col ps-0 pe-2" translate="PLANERA_ARBETSORDER_HEADER_B-MAV"></div>
      <div class="map-popup-table-header col p-0" translate="PLANERA_ARBETSORDER_HEADER_L-MAV"></div>
    </div>
    <div class="row mx-0">
      <div class="col p-0">{{atgard.tallTimmer}}</div>
      <div class="col p-0">{{atgard.granTimmer}}</div>
      <div class="col p-0">{{atgard.klentimmerTall}}</div>
      <div class="col p-0">{{atgard.klentimmerGran}}</div>
      <div class="col ps-0 pe-2">{{atgard.barrmassaved}}</div>
      <div class="col p-0">{{atgard.lovmassaved}}</div>
    </div>
  </div>
  <div class="map-popup-split-container">
    <div class="map-split-left">
      <!-- Medelstam -->
      <table>
        <tr>
          <td class="map-popup-table-header" translate="PLANERA_POPUP_MEDELSTAM"></td>
        </tr>
        <tr>
          <td>
            {{atgard.medelstam | number: '1.2-2'}}
          </td>
        </tr>
      </table>
      <!-- Mark/Väg -->
      <table>
        <tr>
          <td class="map-popup-table-header" translate="PLANERA_ARBETSORDER_HEADER_TILLGANGLIGHET_SKOG"></td>
          <td class="map-popup-table-header" translate="PLANERA_ARBETSORDER_HEADER_BILVAG"></td>
        </tr>
        <tr>
          <td>
            {{atgard.tillganglighetMark}}
          </td>
          <td>
            {{atgard.tillganglighetVag}}
          </td>
        </tr>
      </table>
      <!-- Åtgärdstyp -->
      <table>
        <tr>
          <td class="map-popup-table-header" translate="PLANERA_POPUP_ATGARDSTYP"></td>
        </tr>
        <tr>
          <td>
            {{atgard.atgardstyp}}
          </td>
        </tr>
      </table>
    </div>
    <div class="map-split-right px-2">
      <!-- Volym -->
      <table>
        <tr>
          <td class="map-popup-table-header" translate="PLANERA_POPUP_VOLYM"></td>
        </tr>
        <tr>
          <td>
            {{atgard.volymAtgard | number}}
          </td>
        </tr>
      </table>
      <table>
        <tr>
          <td class="map-popup-table-header">Planerat datum</td>
        </tr>
        <tr>
          <td>
            {{atgard && atgard.planeratDatum ? (atgard.planeratDatum | date:"yyyy-MM-dd") : "-"}}
          </td>
        </tr>
      </table>
      <!-- Planeringsstatus -->
      <table>
        <tr>
          <td class="map-popup-table-header" translate="PLANERA_POPUP_PLANERINGSSTATUS"></td>
        </tr>
        <tr>
          <td>
            {{atgard.planeringsstatus ? atgard.planeringsstatus : ""}}
          </td>
        </tr>
      </table>
    </div>
    <table>
      <tr>
        <td class="map-popup-table-header">Förslag på startdatum från Planerare</td>
      </tr>
      <tr>
        <td>
          {{selectedArbetsorder && selectedArbetsorder.preliminartStartdatum ? (selectedArbetsorder.preliminartStartdatum | date:"yyyy-MM-dd") : "-"}}
        </td>
      </tr>
    </table>
  </div>
  @if (isAtgardAddable === true) {
    <rask-button
      class="ms-auto mb-2 p-0"
      color="primary"
    (click)="addAtgardToArbetsorder()">Lägg till</rask-button>
  }
  @if (atgard.extraordinarHandelse) {
    <div class="eoh-panel-wrapper">
      <div class="eoh-panel">
        <div class="eoh-content">
          EOH: {{ atgard.extraordinarHandelse }}
        </div>
      </div>
    </div>
  }
}
